import {
  GET_ALLCONTACTSUBMISSION,
  UPDATE_CONTACTSUBMISSION,
  DELETE_CONTACTSUBMISSION,
  LOADING_CONTACTSUBMISSION,
  STOP_LOADING_CONTACTSUBMISSION,
} from "../types";

const initialState = {
  contactSubmissions: [],
  total: 0,
  loading_state: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case GET_ALLCONTACTSUBMISSION:
      return {
        ...state,
        contactSubmissions: action.payload.data,
        newContactSubmissions: action.payload.data.filter(
          (submission) => submission.status === 0
        ),
        total: action.payload.total,
      };
    case LOADING_CONTACTSUBMISSION:
      return {
        ...state,
        loading_state: true,
      };
    case STOP_LOADING_CONTACTSUBMISSION:
      return {
        ...state,
        loading_state: false,
      };
    case UPDATE_CONTACTSUBMISSION: {
      const index = state.contactSubmissions.findIndex(
        (x) => x.id === action.payload.id
      );
      const updatedSubmissions = [...state.contactSubmissions];
      if (index !== -1) {
        updatedSubmissions[index] = {
          ...updatedSubmissions[index],
          ...action.payload,
        };
      }
      return {
        ...state,
        contactSubmissions: updatedSubmissions,
        loading_state: false,
      };
    }
    case DELETE_CONTACTSUBMISSION:
      return {
        ...state,
        contactSubmissions: state.contactSubmissions.filter(
          (x) => x.id !== action.payload
        ),
        loading_state: false,
      };
    default:
      return state;
  }
}
